module.exports = __webpack_public_path__ + "img/acuvue__banner.0f15bd9.png?v=1747398688961";